<script lang="ts">
  import { ResponsiveVars } from '@twist/core';
  import { css, cx } from '@emotion/css';

  interface Props {
    color?: string;
  }

  let { color = '#000' }: Props = $props();

  const responsiveVars = new ResponsiveVars()
    .addFluid('inner-mx', [
      ['lg', 'max', 34, 68],
      ['max', 68]
    ])
    .toCSS();

  let colorVar = $derived(css`
    --barColor: ${color};
  `);
</script>

<div class={cx(responsiveVars, colorVar, 'page-foreground', 'outer')}>
  <div class="inner">
    <div class="bar left"></div>
    <div class="bar right"></div>
  </div>
</div>

<style lang="scss">
  @import 'src/scss/media';

  $full-width: $max-width-page - 2 * $max-width-margin;

  .outer {
    position: fixed;
    top: 0;
    z-index: map-get($zIndex, page-foreground);
    width: 100%;
    height: 100vh;
    display: none;
    pointer-events: none;

    @include at('lg') {
      display: block;
    }
  }

  .inner {
    display: flex;
    height: 100%;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
    pointer-events: none;

    @include at('lg') {
      margin: var(--twist-core-spacing-0) var(--inner-mx);
    }

    @include at('max') {
      margin: var(--twist-core-spacing-0) auto;
      max-width: $full-width;
    }
  }

  .bar {
    width: 1px;
    background: var(--barColor);
    height: 100%;
  }
</style>
